export interface Product {
  id: string;
  name: string;
  description: string;
  price: number;
  originalPrice?: number;
  category: ProductCategory;
  images: string[];
  unit: string;
  inStock: boolean;
  stockQuantity: number;
  rating: number;
  reviews: number;
  featured: boolean;
  organic: boolean;
  origin: string;
  createdAt: string;
}

export type ProductCategory = 
  | 'vegetables'
  | 'fruits'
  | 'grains'
  | 'dairy'
  | 'poultry'
  | 'herbs'
  | 'legumes'
  | 'seeds';

export interface Category {
  id: ProductCategory;
  name: string;
  description: string;
  image: string;
  itemCount: number;
}

export const CATEGORIES: Category[] = [
  {
    id: 'vegetables',
    name: 'Fresh Vegetables',
    description: 'Farm-fresh vegetables delivered directly to you',
    image: 'https://images.unsplash.com/photo-1540420773420-3366772f4999?w=400',
    itemCount: 24,
  },
  {
    id: 'fruits',
    name: 'Fresh Fruits',
    description: 'Sweet and juicy fruits from local farms',
    image: 'https://images.unsplash.com/photo-1619566636858-adf3ef46400b?w=400',
    itemCount: 32,
  },
  {
    id: 'grains',
    name: 'Grains & Cereals',
    description: 'Quality grains and cereals for your pantry',
    image: 'https://images.unsplash.com/photo-1574323347407-f5e1ad6d020b?w=400',
    itemCount: 18,
  },
  {
    id: 'dairy',
    name: 'Dairy Products',
    description: 'Fresh milk, cheese, and dairy products',
    image: 'https://images.unsplash.com/photo-1628088062854-d1870b4553da?w=400',
    itemCount: 15,
  },
  {
    id: 'poultry',
    name: 'Poultry & Eggs',
    description: 'Farm-fresh poultry and eggs',
    image: 'https://images.unsplash.com/photo-1582722872445-44dc5f7e3c8f?w=400',
    itemCount: 12,
  },
  {
    id: 'herbs',
    name: 'Fresh Herbs',
    description: 'Aromatic herbs for cooking and wellness',
    image: 'https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=400',
    itemCount: 20,
  },
  {
    id: 'legumes',
    name: 'Legumes & Pulses',
    description: 'Protein-rich legumes and pulses',
    image: 'https://images.unsplash.com/photo-1600096194534-95cf5ece04cf?w=400',
    itemCount: 16,
  },
  {
    id: 'seeds',
    name: 'Seeds & Seedlings',
    description: 'Quality seeds for your garden',
    image: 'https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=400',
    itemCount: 25,
  },
];

